import { ILandingPageOption } from "./LandingPageOption";
import { IProject } from "./Project";
import { IUserData } from "./Users";

export enum E_LANDING_PAGE_TYPE {
  SUBDOMAIN = "subdomain",
  CUSTOM = "custom",
}

export type TMappingLandingPage = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  projectId: string;
  userId: string;
  domain: string;
  name: string;
  layout: null;
  type: null;
  layoutOption: null;
};
export interface OptionMapping {
  id: string;
  createAt: string;
  updateAt: string;
  deletedAt: string | null;
  active: boolean;
  landingPage: TMappingLandingPage;
  landingPageOption: ILandingPageOption;
}

export interface ILandingPageApiResponse {
  id: string;
  project: IProject;
  user: IUserData;
  domain: string;
  name: string;
  deleteAt?: string;
  optionMappings: OptionMapping[];
}

export interface ILandingPage {
  id: string;
  project?: IProject;
  user?: IUserData;
  domain: string;
  name: string;
  deleteAt?: string;
  isAdd?: boolean; // custom field from table when add new landing page
  projectId?: string;
  userDomainId?: string;
  userId?: string;
  optionMappings: OptionMapping[];
  headerScript?: string;
  bodyScript?: string;
  enquiryScript?: string;
  useEnquiryScript?: boolean | null;
  useProjectSgTrackingId?: boolean;
  cNameTargetDomain?: string;
  subDomain?: string;
  customDomain?: string;
  type: E_LANDING_PAGE_TYPE | null;
  dataScript?: Record<string, any>;
  cNameTarget?: string;
}

export class LadingPage {
  id: string;
  project: IProject;
  user: IUserData;
  domain: string;
  name: string;
  deleteAt?: string;

  constructor(data: ILandingPageApiResponse) {
    this.id = data.id;
    this.project = data.project;
    this.user = data.user;
    this.domain = data.domain;
    this.name = data.name;
    this.deleteAt = data.deleteAt;
  }
}

export interface ILandingPageDataForm {
  // domain?: string;  From now domain will be auto fill follow type of landing page - subdomain or custom
  cNameTargetDomain?: string;
  subDomain?: string;
  customDomain?: string;
  type: E_LANDING_PAGE_TYPE;
  name?: string;
  projectId?: string;
  userDomainId?: string;
  domain?: string;
  dataScript?: Record<string, any>;
  cNameTarget?: string;
}

export interface ICheckCNames {
  cNameTargetDomain: string;
  cNameTarget: string;
}
